import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import DotsIcon from "Assets/SVG/DotsIcon";
import {useProjects} from "../../Apis/ProjectApi";
import {ProjectSettlementSettingsDto} from "../../Apis/Models/ProjectSettlementSettingsDto";
import React from "react";
import Space from "../../Components/Space";

interface IProps {
    settlementSettings?: ProjectSettlementSettingsDto[];
    isLoading: boolean;
}
const ProjectSettlementSettingsList = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { settlementSettings, isLoading } = props;

    const { data: projects } = useProjects({includeAll: true})
    
    const navigate = useNavigate();
    
    return (
        <List<ProjectSettlementSettingsDto> data={settlementSettings} loading={isLoading} columns={[
            {
                title: t('project'),
                textRender: (record) => projects ? projects.items.find(x => x.id === record.projectId)!.name : ''
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) =>
                    (
                        <Space direction={"horizontal"} size={"large"}>
                            <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/settlements/settlementSettings/edit/${record.id}`)} >
                                <DotsIcon />
                            </FlexRow>
                        </Space>
                    )
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default ProjectSettlementSettingsList
